// Puppl brand tokens — used in headers, footers, emails, certs, manifests.
// Palette drawn from the Puppl mark: teal oval, black-and-white border collie,
// cream scroll, red ribbon.

export const BRAND_LOGO =
  "https://customer-assets.emergentagent.com/job_force-free-test/artifacts/4hyqg9d0_Untitled%20design.png";

export const BRAND_NAME = "Puppl";
export const BRAND_TAGLINE = "The all-in-one platform for modern dog trainers.";
export const BRAND_AI_NAME = "Sam";

export const BRAND_COLORS = {
  // Primary teal — main brand colour, CTAs, links, active nav, focus rings
  teal: "#33C095",
  tealDeep: "#1F9577",   // hover / pressed
  tealSoft: "#E5F4EE",   // pale wash for highlight cards / chips
  tealMist: "#F0F9F4",   // page-level wash

  // Warm neutrals — the cream scroll in the mark
  cream: "#FAF6EC",      // page background
  paper: "#FFFFFF",      // surface cards
  parchment: "#FFFCF4",  // off-white surface
  border: "#E8DFCD",     // hairline divider

  // Ink — drawn from the dog's black
  ink: "#0F1614",
  inkSoft: "#1F2A26",
  muted: "#4E5A56",      // secondary text
  mutedSoft: "#7A8580",

  // Accent — the red ribbon. Used sparingly for danger / secondary attention.
  ribbon: "#D9352A",
  ribbonDeep: "#B12819",

  // Legacy aliases (kept so any leftover refs in components don't break)
  orange: "#33C095",
  orangeDeep: "#1F9577",
  mossSoft: "#E5F4EE",
  cocoa: "#4E5A56",
};
